var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_3782)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7143 0C45.1769 0 47.5392 0.978715 49.2812 2.71886C51.0213 4.46086 52 6.82314 52 9.28572V31.5714C52 34.034 51.0213 36.3963 49.2812 38.1383C47.5392 39.8784 45.1769 40.8571 42.7143 40.8571H9.28571C6.82314 40.8571 4.46087 39.8784 2.71887 38.1383C0.978723 36.3963 0 34.034 0 31.5714V9.28572C0 6.82314 0.978723 4.46086 2.71887 2.71886C4.46087 0.978715 6.82314 0 9.28571 0H42.7143ZM25.8143 22.2857H33.4286V26C33.4286 27.0251 34.2606 27.8571 35.2857 27.8571C36.3109 27.8571 37.1429 27.0251 37.1429 26V22.2857H40.8571V26C40.8571 27.0251 41.6891 27.8571 42.7143 27.8571C43.7394 27.8571 44.5714 27.0251 44.5714 26V22.2857C44.5714 20.2336 42.9093 18.5714 40.8571 18.5714H25.8143C24.9526 14.3353 21.203 11.1429 16.7143 11.1429C11.5886 11.1429 7.42857 15.3029 7.42857 20.4286C7.42857 25.5543 11.5886 29.7143 16.7143 29.7143C21.203 29.7143 24.9526 26.5219 25.8143 22.2857Z",
    fill: "url(#paint0_linear_62_3782)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2857 20.4286C22.2857 23.504 19.7897 26 16.7143 26C13.6388 26 11.1428 23.504 11.1428 20.4286C11.1428 17.3531 13.6388 14.8571 16.7143 14.8571C19.7897 14.8571 22.2857 17.3531 22.2857 20.4286ZM33.4285 44.5714V48.2857H39C40.0251 48.2857 40.8571 49.1177 40.8571 50.1429C40.8571 51.168 40.0251 52 39 52H13C11.9748 52 11.1428 51.168 11.1428 50.1429C11.1428 49.1177 11.9748 48.2857 13 48.2857H18.5714V44.5714H33.4285Z",
    fill: "url(#gradient_fill)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_fill",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "11.45%",
    stopColor: "#FFBE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8D0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_3782",
    x1: 25.9983,
    y1: 0.472697,
    x2: 25.9983,
    y2: 40.3148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64BCD2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_3782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.14406e570e4caa43ca24464e97a3423e.svg";
export { ForwardRef as ReactComponent };